/**
 * Menu Model
 */

define(function(require, exports, module) {
    'use strict';

    var _ = require('underscore');
    var utils = require('utils');
    var device = require('util/device.util');
    var config = require('config');
    var user = require('user');
    var urlUtil = require('util/url.util');
    var MenuModel = require('modules/menu/menu.model');

    module.exports = MenuModel.extend({

        itemConfig: {
            mobile: {
                expandable: 'expandablePageMobile',
                expandedByDefault: 'expandedByDefaultMobile'
            },
            tablet: {
                expandable: 'expandablePageTablet',
                expandedByDefault: 'expandedByDefaultTablet'
            }
        },

        getInitialClonedItems: function() {
            var clonedItems = utils.deepClone(config.get('menuItems'));
            const showInbox = user.getReceiveInboxStatus();

            var updateFriendlyUrl = function(item) {
                const rootPage = urlUtil.getCleanUrl(config.get('rootPage'));

                if (item.url === '/') {
                    item.friendlyURL = '/';
                }

                /* TotalCasino changes */
                if (item.url === rootPage) {
                    item.url = '/';
                }
            };

            var traverseMenuItems = function(menuItems, fn) {
                menuItems.forEach(function(item) {
                    fn(item);

                    if (item.children) {
                        traverseMenuItems(item.children, fn);
                    }
                });
            };

            var flattenedItems = [];
            traverseMenuItems(clonedItems, function(item) {
                flattenedItems.push(item);
            });

            var chatConfig = config.get('chatWidget');
            var inboxConfig = config.get('inboxWidget');

            var markMenuItemAsOpener = function(item) {
                if (inboxConfig && inboxConfig.enabled && inboxConfig.counterPage === item.url) {
                    item.inboxOpener = true;

                    if (!showInbox) {
                        item.cssClasses += 'hidden';
                    }
                }

                if (chatConfig && chatConfig.enabled && chatConfig.counterPage === item.url) {
                    item.chatOpener = true;
                }
            };

            flattenedItems.forEach(function(item) {
                markMenuItemAsOpener(item);
            });

            return clonedItems.map(function(item) {
                var isDesktop = device.formFactor === 'desktop';

                updateFriendlyUrl(item);

                // Add dy unit for each menu item
                markMenuItemAsOpener(item);

                if (item.children && !isDesktop) {
                    //For case when item has the same link as one of children
                    item.children.forEach(updateFriendlyUrl);

                    if (_.isUndefined(item.orgName) || item.orgName === '') {
                        var expandable = this.itemConfig[device.formFactor].expandable;
                        var expandedByDefault = this.itemConfig[device.formFactor].expandedByDefault;

                        item.expandable = _.isUndefined(item.expandable) ? true : item[expandable];
                        item.expandedByDefault =
                            _.isUndefined(item.expandedByDefault) ? false : item[expandedByDefault];

                    } else {
                        _.each(item.children, function(child) {
                            if (child.children) {
                                child.expandable = true;
                                child.expandedByDefault = false;
                            }
                        });
                    }
                }

                return item;
            }.bind(this));
        },

        getCurrentItem: function(friendlyURL) {
            const sportsbookRootURL = this.getSportsbookRootURL();

            function find(items, path) {
                return utils.deepFind(items, 'children', 'friendlyURL', path) ||
                    utils.deepFind(items, 'children', 'url', path);
            }

            let filteredItems = this._findAmongFilteredItems(find, friendlyURL);

            if (_.isEmpty(filteredItems) && this.isSportPage(urlUtil.pathname)) {
                filteredItems = this._findAmongFilteredItems(find, sportsbookRootURL);
            }

            return filteredItems;
        }
    });
});
